/* eslint-disable @typescript-eslint/naming-convention */
type strObj = { [key: string]: string }

export const routes: strObj = {
    default: '/',
    news: '/news/:id'
}
